<template>
  <div class="support">
    <div class="section-background">
      <div class="container">
        <div class="hero">
          <div class="text">
            <p class="sub-title">
              Walkthrough videos
            </p>
            <h1 class="title">
              Get started videos
            </h1>
            <div
              v-b-toggle.collapse-9
              class="FAQ-question collapsed"
            >
              <b>Upload video</b>
              <span>Video | Assign video | Tag video</span>
            </div>
            <b-collapse
              id="collapse-9"
              class="FAQ-answer"
            >
              <div class="row">
                <div class="col-md-6">
                  <iframe
                    height="400"
                    width="600"
                    src="https://www.youtube.com/embed/3S4-tOwrGmE"
                    frameborder="0"
                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen
                  />
                </div>
                <div class="col-md-6">
                  <p>
                    As a player or coach, upload your training videos by
                    selecting the “Upload” button. It is important to make sure
                    that you are uploading to the correct “Club”, if associated
                    to multiple organisations.
                  </p>
                  <ul>
                    <li>
                      A video requirements page will pop up for the
                      recommendations of a good quality video. Select continue
                      to proceed.
                    </li>
                    <li>
                      On the “Upload Video” page, select the “Select Session
                      Date” input field and insert the training date of your
                      video session. Select the “Select Team” input field to
                      designate for which team the videos will be uploaded.
                      Under the “Select videos” field, you have the option to
                      either “Drag and Drop” video files, or to “Choose Videos”
                      from file by clicking the field when it is highlighted.
                      You will be able to upload 10 videos at once. Beneath each
                      video, in the “Type player name to search” input field,
                      start inputting the players name of that team or choose
                      the correct player name from the list of players in that
                      team. In the “Tag your video”, input field, add multiple
                      relevant tags that will help you search for that specific
                      video at a later stage. Select the correct radio button
                      for the kind of video that has been filmed.
                    </li>
                  </ul>

                  <p>
                    Repeat the steps of player name, tagging and selecting the
                    correct radio button for each of the other uploaded videos
                    if more than one player video has been uploaded. As a player
                    uploading videos, your name will automatically appear as the
                    designated player name.
                  </p>
                  <p>
                    Once all required fields are complete, click the upload
                    button and allow for the green status bar to complete for
                    each video upload before heading back to the home page.
                  </p>
                </div>
              </div>
            </b-collapse>
            <div
              v-b-toggle.collapse-1
              class="FAQ-question collapsed"
            >
              <b>Organisation settings</b>
              <span>Settings | Theming | Report settings | Logo</span>
            </div>
            <b-collapse
              id="collapse-1"
              class="FAQ-answer"
            >
              <div class="row">
                <div class="col-md-6">
                  <iframe
                    height="400"
                    width="600"
                    src="https://www.youtube.com/embed/6qpZGAWiQPc"
                    frameborder="0"
                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen
                  />
                </div>
                <div class="col-md-6">
                  <p>
                    As an owner and administrator: Click on the settings' icon
                    to change the colouring, logo, name, and video analysis
                    report settings.
                  </p>
                  <ul>
                    <li>
                      To change the name of your organisation click on the input
                      field name and start typing.
                    </li>
                    <li>
                      The organisation logo can be uploaded or changed by
                      selecting, “Change Club Logo” and then selecting from file
                      on your device.
                    </li>
                    <li>
                      To set or change the primary and secondary colouring of
                      your organisation, click on the input field and enter a
                      HEX code or colour name.
                    </li>
                  </ul>
                  <p>
                    Under the section video analysis report settings, you can
                    add the feedback categories of your choice to be included
                    for a PDF report of a specific player video. By clicking on
                    the <b>“Add Feedback Category”</b>, you can add multiple
                    categories for feedback that you would like a part of your
                    analysis report. Once created and added, you can order these
                    categories by selecting the input field <b>“Order”</b>, and
                    change the order number of that category. Toggle the
                    <b>“show time”</b>
                    option to included or not include the time of the category
                    on the report. The delete function is available if the
                    category is no longer applicable for reporting.
                  </p>
                  <p>
                    Once all the required changes have been made,
                    <b>click the save button</b>.
                  </p>
                </div>
              </div>
            </b-collapse>

            <div
              v-b-toggle.collapse-2
              class="FAQ-question collapsed"
            >
              <b>Member management</b>
              <span>Members roles | Add members | User profile | Teams</span>
            </div>
            <b-collapse
              id="collapse-2"
              class="FAQ-answer"
            >
              <div class="row">
                <div class="col-md-6">
                  <iframe
                    height="400"
                    width="600"
                    src="https://www.youtube.com/embed/z_JXHCEDvDg"
                    frameborder="0"
                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen
                  />
                </div>
                <div class="col-md-6">
                  <p>
                    As an owner and administrator: Invite new members and manage
                    existing members according to their user role in your
                    organisation and their role in a specific team by clicking
                    on the members' icon.
                  </p>
                  <ul>
                    <li>
                      Invite new members to your organisation by selecting the
                      “Invite Members” button. You can input the email id for
                      multiple new member invitations. Select “invite” once
                      done. New members will automatically be sent a
                      notification to create their login details for access to
                      your organisation.
                    </li>
                    <li>
                      The filter option allows you to search for a specific
                      member, or filter on specific user roles.
                    </li>
                    <li>
                      Manage and edit your users individually by selecting their
                      user profile. You can change or correct the name of the
                      user by clicking on the input field name to start typing.
                    </li>
                    <li>
                      Organisational role of users: By selecting the dropdown
                      for “Roles in your Organization” section, you can provide
                      role based access as an admin with full platform
                      functionality, or reduced functionality for a standard
                      member or as a guest with limited functionality within the
                      organisation.
                    </li>
                    <li>
                      Team role of users: By selecting the “choose team”
                      dropdown, under the “Role in Team” section, you can place
                      a user in an existing team of your organisation. When a
                      user is added to a team, you will need to select their
                      role in that team from the “Choose role” dropdown.
                      Selecting either player, coach or guest as their role. The
                      guest role has read only functionality within that team,
                      and usually is associated to a parent account user. Once
                      the team and role has been chosen, select the “Add” option
                      to save these changes. You can remove the user from a
                      particular team by selecting the “Remove” option.
                    </li>
                  </ul>

                  <p>
                    A player can be added to multiple existing teams within the
                    organisation and a specific role assigned in that particular
                    team.
                  </p>
                  <p>
                    Exit out of the profile to return to the manage members
                    page.
                  </p>
                </div>
              </div>
            </b-collapse>

            <div
              v-b-toggle.collapse-3
              class="FAQ-question collapsed"
            >
              <b>Drills</b>
              <span>Private & Public drills | Assign drills | </span>
            </div>
            <b-collapse
              id="collapse-3"
              class="FAQ-answer"
            >
              <div class="row">
                <div class="col-md-6">
                  <iframe
                    height="400"
                    width="600"
                    src="https://www.youtube.com/embed/Q-PpGcaEvkM"
                    frameborder="0"
                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen
                  />
                </div>
                <div class="col-md-6">
                  <p>
                    As an admin or coach, view and add drills by clicking on the
                    “Drills” icon. As a player you can view the library of
                    drills, or the drills that have been assigned to you as a
                    player specifically.
                  </p>
                  <ul>
                    <li>
                      From this page you can select and view “My Drills” which
                      are private drills created within your organisation. You
                      can also view the “Public drills” that have been made
                      available across the Ludimos community. Toggle between
                      these two buttons and the page numbers for a view of all
                      available drills. When selecting a drill, the description,
                      overview and steps of the drill will be presented. Click
                      on the back button to move to the drills page.
                    </li>
                    <li>
                      The “My assigned drills” button, is a view of all drills
                      that have been assigned to you, as specific player
                      feedback on your uploaded videos. Select the drill icon to
                      view the drill that was assigned to you.
                    </li>
                    <li>
                      The filter option allows you to search for a specific
                      drill, or to filter on the specific category of drill,
                      batting, bowling, fielding etc.
                    </li>
                  </ul>

                  <p>
                    To add a drill as a coach, select the
                    <b>“Add Drill”</b> button. To name the drill, click on the
                    input field name and start typing. Select the dropdown under
                    <b>“Category”</b>, to select the category affiliation of the
                    drill. By selecting the <b>“Tag”</b> input field, you can
                    leave in appropriate tags, to search and find the specific
                    tag and associated drill at a later stage. The
                    <b>“make public”</b> toggle will leave the drill as a
                    private one for your organisation, or it will be available
                    for viewing across the Ludimos community. When highlighted
                    purple, the drill is set to public. Describe the drill by
                    clicking the input field and typing in the overview and
                    description of the drill. You can break down the drill into
                    steps, by clicking on the input field and describing the
                    first aspect of the drill. You can follow up the description
                    with a browsed image or video from file on your device.
                    Links such as Youtube can additionally be added as part of
                    the description. Select the <b>“Add Step 2”</b> button to
                    add an additional step to your drill and follow the same
                    input steps as mentioned. Once all the steps of the drill
                    are completed, Save the drill which can be found in either
                    <b>“My Drills” or “Public Drills”</b>.
                  </p>
                </div>
              </div>
            </b-collapse>

            <div
              v-b-toggle.collapse-4
              class="FAQ-question collapsed"
            >
              <b>Redeem coupon</b>
              <span>Marketplace | 1-on-1 coaching | online coaching</span>
            </div>
            <b-collapse
              id="collapse-4"
              class="FAQ-answer"
            >
              <div class="row">
                <div class="col-md-6">
                  <iframe
                    height="400"
                    width="600"
                    src="https://www.youtube.com/embed/hwUiKF_sNmI"
                    frameborder="0"
                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen
                  />
                </div>
                <div class="col-md-6">
                  <p>
                    Redeem a bought marketplace coupon, by selecting the
                    <b>“Redeem Coaching Coupon”</b> button. This is the same
                    coupon code received via email or on the web page when the
                    coaching order was processed.
                  </p>
                  <p>
                    Insert the coupon code in the pop up coupon code input
                    field. The valid coupon code will automatically connect you
                    to the correct online coaching service for your video
                    uploads.
                  </p>
                  <p>
                    This coaching service will appear as one of your affiliated
                    clubs.
                  </p>
                </div>
              </div>
            </b-collapse>

            <div
              v-b-toggle.collapse-5
              class="FAQ-question collapsed"
            >
              <b>Video page and reports </b>
              <span>Video | frame-by-frame | Ludimos AI | Feedback | Reports</span>
            </div>
            <b-collapse
              id="collapse-5"
              class="FAQ-answer"
            >
              <div class="row">
                <div class="col-md-6">
                  <iframe
                    height="400"
                    width="600"
                    src="https://www.youtube.com/embed/9THhsqPAFnI"
                    frameborder="0"
                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen
                  />
                </div>
                <div class="col-md-6">
                  <p>
                    As a coach providing feedback, when reviewing videos from
                    the <b>“Unreviewed Videos”</b> or
                    <b>“Training session”</b> tabs, click the player video that
                    is to be analysed. This will bring you to the Video Detail
                    Page.
                  </p>
                  <p>
                    From the Video Details Page you can play the video by
                    selecting the play icon or clicking on the video itself. You
                    can pause a video by using the space bar on your keyboard,
                    clicking on the video or clicking the pause icon. You can
                    additionally move across the video time line, by clicking
                    along or dragging the cursor to a preferred time. The audio,
                    mute functionality and volume can be controlled with the
                    audio icon and volume slider bar.
                  </p>

                  <p>
                    You can speed up or slow down the video on the video
                    dashboard, or also by using the up and down arrows on your
                    keyboard. Use the full screen icon to enhance your visuals.
                    When a video is paused on a frame, you can rock and roll
                    between frames with the minus/plus one icons, or with the
                    left and right arrows on your keyboard.
                  </p>

                  <p>
                    For the use of Ludimos AI, use the
                    <b>“Skip Pauses”</b> toggle to skip all unnecessary noise,
                    leaving you only relevant action points. Leave the
                    <b>“Skip Pauses”</b> off if you wish to watch the entire
                    uploaded video and hear all of its audio captured.
                  </p>
                  <p>
                    As a coach, when you have identified an action for analysis,
                    click the <b>“Add Feedback”</b> button. How to provide
                    feedback is covered in the Feedback video of this navigation
                    series.
                  </p>
                  <p>
                    Every time feedback is provided on a video, the provided
                    text, diagrams, voice notes and drills will be provided
                    along a timeline of feedback. When a coach or player selects
                    one of these feedback cards, the user will be taken to the
                    correct frame of feedback on the video itself. As a player
                    and coach you can delete the feedback card, edit your
                    textual feedback or reply via text on a particular feedback
                    card that was created by you as a player or coach. Players
                    can reply with text to a coaches' feedback.
                  </p>
                  <p>
                    As a coach, when clicking on the <b>“Filter”</b> drop down,
                    you can filter the feedback cards according to the category
                    you have assigned that particular feedback card. These are
                    the same feedback categories created by an owner or admin
                    under settings. How you assign feedback categories is
                    covered in the Feedback video of this navigation series.
                  </p>
                  <p>
                    As a coach you can Generate a pdf report of the that
                    particular video, by clicking <b>“Generate Report”</b>. This
                    report will contain the logo of your organisation, player
                    name, date of the report, all the feedback categories, as
                    well as the time in seconds on the video when textual and
                    visual feedback was provided by the coach for that category.
                    The coach who provided the feedback will also display on
                    this report.
                  </p>
                </div>
              </div>
            </b-collapse>

            <div
              v-b-toggle.collapse-6
              class="FAQ-question collapsed"
            >
              <b>Feedback tools </b>
              <span>Drawing | Record voice | Text feedback | Assign drills |
                Feedback category</span>
            </div>
            <b-collapse
              id="collapse-6"
              class="FAQ-answer"
            >
              <div class="row">
                <div class="col-md-6">
                  <iframe
                    height="400"
                    width="600"
                    src="https://www.youtube.com/embed/J2QqU2mPefk"
                    frameborder="0"
                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen
                  />
                </div>
                <div class="col-md-6">
                  <p>
                    As a coach or player of the team, you can provide feedback
                    on any single frame of video content. Once you have
                    determined the frame you would like to drop in feedback on,
                    click the <b>“Add Feedback”</b> button. This will bring you
                    to the feedback panel.
                  </p>
                  <p>
                    As a coach or player you have the option to drop in text and
                    hashtags, categorise the feedback according to the
                    categories created under your organisational settings, add a
                    voice note of up to 30 seconds, and also a corrective drill
                    from your private or the Ludimos public library of drills.
                    Click <b>“Filter”</b> to either filter for a specific
                    category of drill or to search for a drill. You can also
                    assign how many repetitions of that drill that the player is
                    to perform. Click <b>“Add Selected Drill”</b>, once the
                    chosen drill and frequency has been set. The exit option is
                    also available if you are not assigning a drill and need to
                    exit the library.
                  </p>
                  <p>
                    When using the drawing tools you can change between
                    different colours, draw with straight lines, draw with free
                    lines, use shapes such as squares and circles, erase a
                    specific drawing feedback, or erase the visual feedback as a
                    whole.
                  </p>
                  <p>
                    The exit option is also available if you wish to exit the
                    feedback panel without providing feedback for that frame.
                  </p>
                  <p>
                    Once all the necessary feedback has been provided, and the
                    added drill is selected, click the <b>“Send” button</b>.
                    Players will automatically receive an email feedback
                    notification when feedback is provided on their videos. All
                    feedback and drills provided will then display below the
                    video, on the video details page as a timeline of feedback.
                  </p>
                </div>
              </div>
            </b-collapse>

            <div
              v-b-toggle.collapse-7
              class="FAQ-question collapsed"
            >
              <b>Player profile and performance </b>
              <span>Performance | Profile | Match detail | Batting | Bowling |
                Fielding</span>
            </div>
            <b-collapse
              id="collapse-7"
              class="FAQ-answer"
            >
              <div class="row">
                <div class="col-md-6">
                  <iframe
                    height="400"
                    width="600"
                    src="https://www.youtube.com/embed/xpy7sqhkD_o"
                    frameborder="0"
                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen
                  />
                </div>
                <div class="col-md-6">
                  <p>
                    To maintain your player profile and performance stats, click
                    on your username. The <b>“General”</b> tab is an overview of
                    your personal detail as well as your cricket related
                    profile. From this tab you can also reset your password.
                    When clicking on the <b>“Reset Password”</b> button, you
                    will be prompted to input your current password, as well as
                    your new password and the confirmation of this new password
                    in the respective input fields. Once completed, click
                    <b>“Save”</b>. Logging out of Ludimos is also done from this
                    tab.
                  </p>
                  <p>
                    The <b>“Videos”</b> tab allows you to view all videos that
                    are uploaded in your name. Clicking on a video will take you
                    to the video details page. From this view, a video can be
                    deleted that is in your name.
                  </p>
                  <p>
                    The <b>“Stats”</b> tab provides for an overall view of your
                    personal match statistics, as well as the option for you to
                    input your stats per match. By clicking the
                    <b>“Add Stats”</b> button, input your stats for a particular
                    game. Through the input fields, provide for the respective
                    match details, including for match data of
                    <b>“Batting”, “Bowling” and “Fielding”</b>. For batting,
                    your <b>“Strike Rate”</b> will automatically be calculated,
                    as well as your <b>“Economy”</b> if you bowled in that game.
                    Click <b>“Save”</b> once completed.
                  </p>
                  <p>
                    The <b>“Edit”</b> tab allows you to edit any personal detail
                    or for your cricket related profile. You are also able to
                    update or change your player profile pic from file, by
                    clicking <b>“Select Image”</b>. Once uploaded, select
                    <b>“Save”</b>. Once the necessary changes have been made to
                    your profile, select the <b>“Save”</b> button.
                  </p>
                </div>
              </div>
            </b-collapse>

            <div
              v-b-toggle.collapse-8
              class="FAQ-question collapsed"
            >
              <b>Team management </b>
              <span>Add team | Private or Public teams | Add members to teams |
                Team settings</span>
            </div>
            <b-collapse
              id="collapse-8"
              class="FAQ-answer"
            >
              <div class="row">
                <div class="col-md-6">
                  <iframe
                    height="400"
                    width="600"
                    src="https://www.youtube.com/embed/O6x0kjtHSiU"
                    frameborder="0"
                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen
                  />
                </div>
                <div class="col-md-6">
                  <p>
                    As an admin and owner, add a new team to your organisation
                    by clicking the <b>“Add Team”</b> icon. Give your team an
                    appropriate name for example, u13s, Academy, 1 to 1s, by
                    typing in the <b>“Team Name”</b> input field. As the
                    administrator, you have the option to make your team Public
                    or Private. In a public team, players can view each other's
                    videos and feedback. In a private team, the player will only
                    be able to view their videos and feedback, together with the
                    coaches of that team. Click the <b>“Create Team”</b> button
                    once done. A lock icon will appear next to the team you have
                    created, if a private option was chosen.
                  </p>
                  <p>
                    When a team is selected, you have the option to view
                    unreviewed videos, or videos as according to the dates of
                    training sessions under the these respective tabs. An
                    overview of the members of your team, searching for a member
                    of that team, adding existing members already in your
                    organisation and adding new members to the team can be
                    managed under the <b>“Members”</b> tab. Click
                    <b>“Add new members”</b> to invite a new member to your team
                    and organisation. In the input field, type or copy in the
                    members email. You can add multiple addresses. Click
                    <b>“add role”</b> to associate the new member to a specific
                    role of that team, Player, Coach or Guest. Click
                    <b>“Add”</b> and these members will receive an email
                    notification to set up their account and login details for
                    your organisation.
                  </p>
                  <p>
                    If a player is already a part of your organisation, click
                    <b>“Add Existing Members”</b>. In the input field, start
                    typing the players name and their name will appear if
                    already part of your organisation. You can add multiple
                    names at once. Click <b>“Add Role”</b> to associate that
                    member to a specific role of that team, Player, Coach or
                    Guest.
                  </p>
                  <p>
                    As an admin or owner, you also have an overview of the data
                    statistics of this particular team, its overview, video and
                    feedback trends, as well as a coach feedback breakdown.
                  </p>
                  <p>
                    The admin and owner of the organisation also have the option
                    to change the <b>“Settings”</b> of that team. The name and
                    sporting code of that team can be edited and changes, as
                    well as the public or private functionality of the team. Who
                    can upload, player or coach, can also be edited and changed.
                    The functionality of the max length of each video that can
                    be uploaded and also the number of uploaded videos per month
                    for this team can also be adjusted. Zero is unlimited for
                    these two input fields. Once the necessary changes have been
                    made, click the <b>“Save”</b> button.
                  </p>
                </div>
              </div>
            </b-collapse>
          </div>
          <div class="visual">
            <div class="background">
              <img
                src="../assets/img/hero-background.svg"
                alt="background visual"
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Support",
  mounted() {
    this.$ma.trackEvent({
      fb_event: "ViewContent",
      category: "Menu",
      action: "Menu",
      label: "Support",
      type: "Support",
    });
  },
  metaInfo() {
    return {
      title: this.textEllipsis(`Ludimos - Instructions`, 25),
      // meta: [{ name: "theme-color", content: this.getPrimaryHex }]
    };
  },
};
</script>
<style lang="scss" scoped>
.FAQ-question {
  cursor: pointer;
  border-bottom: 1px solid #eee;
  padding: 10px 0 10px 30px;
  position: relative;
  &:before {
    content: "keyboard_arrow_up";
    font-family: "Material Icons";
    position: absolute;
    left: 5px;
    top: 6px;
    font-size: 20px;
  }
  &.collapsed {
    &:before {
      content: "keyboard_arrow_down";
    }
  }
 
  span {
    display: block;
    opacity: 0.7;
    font-size: 12px;
  }
}

.FAQ-answer {
  > div {
    padding: 20px;
    margin: 0;
    background: #f5f5f5;
  }
}
ul {
  list-style: disc;
  padding-left: 30px;
  li {
    font-weight: 600;
  }
}
@media (max-width: 767px) {
  iframe {
    height: 200px;
  }
}
</style>
